import React from 'react'

const CircleSVG: React.FC = () => {
    return (
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 40 40">
            <circle
                fill={'none'}
                stroke={'#000'}
                strokeWidth={2}
                strokeMiterlimit={10}
                cx={20}
                cy={20}
                r={17}
            />
        </svg>
    )
}

export default CircleSVG
